import React from 'react';
import { Header } from './Common/Header';
import { cn } from '@/lib/utils';

interface DialogHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    backgroundColor?: string;
    headerWidth?: string;
    badgeClassName?: string;
}
function DialogHeader({
    title,
    backgroundColor,
    headerWidth,
    className,
    badgeClassName,
    ...props
}: DialogHeaderProps): React.JSX.Element {
    return (
        <div className={cn('flex flex-row items-center justify-between gap-5', className)} {...props}>
            <Header className={badgeClassName} backgroundColor={backgroundColor} headerWidth={headerWidth}>
                {title}
            </Header>
        </div>
    );
}

export default DialogHeader;
